module.exports = __webpack_public_path__ + "img/Live Data Icon_Down.c4e036d5.svg";